import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  paymentAction: null,
  paymentStatus: null,
};

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    setPaymentAction(state, action) {
      state.paymentAction = action.payload;
    },
    setPaymentStatus(state, action) {
      state.paymentStatus = action.payload;
    },
  },
});

export const {
  setPaymentAction,
  setPaymentStatus,
} = paymentSlice.actions;